import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const OrderLinesFinanceSection = "/reports/finance/order-lines";

export const OrderLinesFinanceListPath = OrderLinesFinanceSection;

export enum OrderLinesFinanceListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  tenantType = "tenantType",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo",
  orderCanceledFrom = "orderCanceledFrom",
  orderCanceledTo = "orderCanceledTo",
  paymentMethodType = "paymentMethodType"
}

export enum OrderLinesFinanceListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand",
  orderStatus = "orderStatus",
  deliveryType = "deliveryType"
}

export type OrderLinesFinanceListUrlDialog = "download" | TabActionDialog;
export type OrderLinesFinanceListUrlFilters = Filters<
  OrderLinesFinanceListUrlFiltersEnum
> &
  FiltersWithMultipleValues<OrderLinesFinanceListUrlFiltersWithMultipleValues>;

export type OrderLinesUrlQueryParams = ActiveTab &
  OrderLinesFinanceListUrlFilters &
  BulkAction &
  Dialog<OrderLinesFinanceListUrlDialog> &
  Pagination &
  SingleAction;

export const OrderLinesFinanceListUrl = (params?: OrderLinesUrlQueryParams) =>
  OrderLinesFinanceListPath + "?" + stringifyQs(params);
